import * as types from '../types.js';

export default {

	html: `
		<style>
			#sm-split #stock_sku { width: 12rem; }
			#sm-split #quantity_first { width: 8rem; text-align: right; }
		</style>
		<form id="sm-split" class="form" autocomplete="off">
			<div class="title">Dividir linha de estoque</div>
			<p class="mts muted" style="max-width:34rem">Exige reserva e bloqueio zerados. Informe a quantidade que permanece na linha atual; o restante gera uma nova linha na mesma posição/lote.</p>
			<div class="fsb mtl">
				<label>SKU
					<input id="stock_sku" type="text" disabled>
				</label>
				<label>Disponível (atual)
					<input id="qty_available" type="text" disabled>
				</label>
				<label>Qtde na linha atual após split<sup>*</sup>
					<input id="quantity_first" type="text" required>
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Dividir</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#sm-split',
		init(formset) {
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#stock_sku' }, types: [] },
		{ properties: { selector: '#qty_available' }, types: [] },
		{ properties: { selector: '#quantity_first' }, types: [ types.number(0, 2) ] },
	],
};
